import React, { useEffect } from 'react';
import AOS from 'aos';
import "aos/dist/aos.css";
import './index.css';
import {
  BrowserRouter as Router,
  Routes,
  Route
} from 'react-router-dom';
// All pages
import Home from './pages/Home';
import Contact from './pages/Contact';
import DemoProduct from './pages/DemoProduct';

import { useDocTitle } from './components/CustomHook';
import ScrollToTop from './components/ScrollToTop';
import Clients from './components/Clients';
import About from './pages/About';
import Layout from './components/Layout';
import Accounting from './pages/Accounting';
import Application from './pages/Application';
import Consulting from './pages/Consulting';
import Digitalmarketing from './pages/Digitalmarketing';
import Staffing from './pages/Staffing';
import Careers from './pages/Careers';
import Telecom from './pages/Telecom';
import Apply from './pages/Apply';
import Signup from './pages/Signup';
import Login from './pages/Login';
import Email from './pages/Email';
import ContactVerify from './pages/ContactVerify';
import Otp from './pages/Otp';
import EmailVerify from './pages/EmailVerify';
import ForgotPasswordForm from './pages/ForgotPasswordForm';
import ChangePassword from './pages/ChangePassword';
import StripeRedirectHandler from './pages/StripeRedirectHandler';
import Digitalcommunication from './pages/Digitalcommunication';
import SupportedPhones from './pages/SupportedPhones';

function App() {
  useEffect(() => {
    const aos_init = () => {
      AOS.init({
        once: true,
        duration: 1000,
        easing: 'ease-out-cubic',
      });
    }

    window.addEventListener('load', () => {
      aos_init();
    });
  }, []);

  useDocTitle("Quadprosoft Technologies inc");

  return (
    <>
      <Router>
        <ScrollToTop>
          <Layout>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/about" element={<About />} />
              <Route path="/accounting" element={<Accounting />} />
              <Route path="/application-development" element={<Application />} />
              <Route path="/consulting" element={<Consulting />} />
              <Route path="/digital-marketing" element={<Digitalmarketing />} />
              <Route path="/staffing" element={<Staffing />} />
              <Route path="/careers" element={<Careers />} />
              <Route path="/telecommunications" element={<Telecom />} />
              <Route path="/clients" element={<Clients />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/get-demo" element={<DemoProduct />} />
              <Route path="/career-form" element={<Apply />} />
              <Route path="/signup" element={<Signup />} />
              <Route path="/login" element={<Login />} />
              <Route path="/email" element={<Email />} />
              <Route path="/email" element={<Email />} />
              <Route path='/contactverify' element={<ContactVerify />} />
              <Route path="/otp" element={<Otp />} />
              <Route path="/verifyEmail/:tokenId" element={<EmailVerify />} />
              <Route path="/forgotPassword" element={<ForgotPasswordForm />} />
              <Route path="/changepassword/:tokenId" element={<ChangePassword />} />
              <Route path="/digitalcommunication" element={<Digitalcommunication />} />
              <Route path="*" element={<StripeRedirectHandler />} />
               <Route path="/telecommunications/supportedphones" element={<SupportedPhones />} />

            </Routes>
          </Layout>
        </ScrollToTop>
      </Router>
    </>
  );
}


export default App;
